/**
 * Artist Help System — distinct injectable system for the Artist interface.
 * Content tree: assets/help/artist/<locale>/...
 */
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { HelpSystemBase } from '../help-system-base';
import { HelpSystemId, RouteHelpMapping } from '../help.types';
import { artistRouteHelpMap } from './artist-route-map';

@Injectable({ providedIn: 'root' })
export class ArtistHelpService extends HelpSystemBase {
  readonly systemId: HelpSystemId = 'artist';
  protected readonly routeMap: RouteHelpMapping[] = artistRouteHelpMap;

  constructor(router: Router) {
    super(router);
  }
}
